// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1A-mu","small":"small-1aOpj","option":"option-rEZIj","big":"big-1pI5_"};